var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-progress-bar" }, [
    _c("div", { staticClass: "c-progress-bar__wrapper" }, [
      _c(
        "div",
        { staticClass: "c-progress-bar__step-wrapper" },
        _vm._l(_vm.steps, function (step, index) {
          return _c(
            "div",
            {
              key: step,
              staticClass: "c-progress-bar__step",
              class: {
                "c-progress-bar__step--active":
                  index == _vm.currentStepByCategory,
                "c-progress-bar__step--valid":
                  index < _vm.currentStepByCategory,
              },
            },
            [
              _c("span", { staticClass: "c-progress-bar__label" }, [
                _vm._v(_vm._s(step)),
              ]),
              _vm._v(" "),
              index !== _vm.steps.length - 1
                ? _c("div", { staticClass: "c-progress-bar__progress" })
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }